import { Pipe, PipeTransform } from '@angular/core';

/**
 * Wraps each line of already-highlighted code (codeHighlight's output) in
 * `<span class="code-line">`, so CSS counters can number the lines.
 * Splitting on "\n" is safe because codeHighlight never lets a token span
 * a line break: its string patterns exclude newlines.
 */
@Pipe({ name: 'codeLines', standalone: false })
export class CodeLinesPipe implements PipeTransform {
  transform(html: string | null | undefined): string {
    if (!html) return '';
    return html.split('\n').map(line => `<span class="code-line">${line}</span>`).join('\n');
  }
}
